import { render } from "./SimpleKeyboard.vue?vue&type=template&id=afe8db4e&scoped=true"
import script from "./SimpleKeyboard.vue?vue&type=script&lang=js"
export * from "./SimpleKeyboard.vue?vue&type=script&lang=js"

import "./SimpleKeyboard.vue?vue&type=style&index=0&id=afe8db4e&scoped=true&lang=css"

import exportComponent from "/Users/francoisgillet/Documents/GitHub/tenjity-module/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afe8db4e"]])

export default __exports__